import * as Sentry from '@sentry/angular-ivy';

export function buildSentryIOOptions(): Sentry.BrowserOptions {

	const domains = {
		// Other.
		'127.0.0.1': {
			environment: 'development'
		},
		'localhost': {
			environment: 'development'
		},
		// APIs - AL3 - custom domain.
		'portal.applicationlink.eu': {
			environment: 'production'
		},
		// APIs - AL3 - azurewebsites.net.
		'applicationlink.azurewebsites.net': {
			environment: 'production'
		},
		'applicationlink-ua.azurewebsites.net': {
			environment: 'user-acceptance'
		},
		'applicationlink-test.azurewebsites.net': {
			environment: 'test'
		},
		// APIs - CSP - azurewebsites.net.
		'cspplatform.azurewebsites.net': {
			environment: 'production'
		},
		'cspplatform-ua.azurewebsites.net': {
			environment: 'user-acceptance'
		},
		'cspplatform-test.azurewebsites.net': {
			environment: 'user-acceptance'
		},
	}

	const sentryOptions: Sentry.BrowserOptions = {
		dsn: 'https://29997be62adda56ab5f6907325bcca67@o4506388793458688.ingest.sentry.io/4506406775554048',
		integrations: [
			new Sentry.BrowserTracing({
				// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
				tracePropagationTargets: [
					...Object.keys(domains),
					// To check if we need this.
					'applicationlink.azureedge.net'
				],
			}),
			new Sentry.Replay({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		// Performance Monitoring
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Session Replay
		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	}

	if (domains[window.location.hostname]) {
		sentryOptions.environment = domains[window.location.hostname].environment;
	}

	return sentryOptions;
}
